export default "__VITE_ASSET__H2uU1p42__"